export default __webpack_public_path__ + "static/media/EOTDREGIONAL.b8151649.pdf";